import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import createRouter from './routes';


Vue.config.productionTip = false;

const router = createRouter();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
